/**
 * Shared v3 stack-screen shell tokens + legacy alias for `ScreenShell`.
 */
import { StyleSheet, type TextStyle, type ViewStyle } from 'react-native';
import { appTheme, type ThemeColors } from '..';
import { hexToRgba } from '../colorUtils';
import { androidFlatSurfaceStyle, androidScaleFont, androidScaleSize } from '../androidUiParity';
import { DASHBOARD_PADDING_H, DASHBOARD_SECTION_GAP, DASH_STUDIO_INNER, DASH_STUDIO_RADIUS, studioCardShell } from './dashboardConstants';

export { ScreenShell as StackScreenShell, ScreenShell } from './ScreenShell';
export type { ScreenShellProps as StackScreenShellProps, ScreenShellProps } from './ScreenShell';

export { DASHBOARD_PADDING_H, DASHBOARD_SECTION_GAP, DASH_STUDIO_INNER, DASH_STUDIO_RADIUS, studioCardShell };
export { androidFlatSurfaceStyle, androidScaleFont, androidScaleSize };

export function studioSectionCardStyle(colors: ThemeColors, extra?: ViewStyle): ViewStyle {
  return StyleSheet.flatten([
    studioCardShell(colors),
    {
      backgroundColor: colors.surface,
      borderRadius: DASH_STUDIO_RADIUS,
      overflow: 'hidden',
    },
    extra,
  ]);
}

export function studioSectionLabelStyle(colors: ThemeColors): TextStyle {
  return {
    ...appTheme.typography.captionSmall,
    fontSize: androidScaleFont(11),
    fontWeight: '700',
    letterSpacing: 0.6,
    marginBottom: appTheme.spacing.sm,
    marginStart: appTheme.spacing.xs,
    color: hexToRgba(colors.text, 0.72),
    textTransform: 'uppercase',
  };
}

export const STACK_SCROLL_GUTTER = DASHBOARD_PADDING_H;
export const STACK_SECTION_GAP = DASHBOARD_SECTION_GAP;
